export default "__VITE_ASSET__Dl575jZa__"